import { SEVERITY } from "helpers/utils.js";
import {
  GET_STOCK_INS,
  GET_STOCK_INS_SUCCESS,
  GET_STOCK_IN_BY_ID_SUCCESS,
  GET_STOCK_INS_ERROR,
  STOCK_IN_CLEAR_ERROR,
  GET_CONFIRM_STOCK_IN,
  GET_CONFIRM_STOCK_IN_SUCCESS,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
  message: null,
};

const StockIn = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_CONFIRM_STOCK_IN:
    case GET_STOCK_INS:
      return {
        ...state,
        loading: true,
      };
    case GET_CONFIRM_STOCK_IN_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
        message: {
          title: "Stock In",
          text: "Stock In has been confirmed successfully.",
          severity: SEVERITY.SUCCESS,
        },
      };
    case GET_STOCK_INS_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_STOCK_IN_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_STOCK_INS_ERROR:
      let hasUniqueCode = payload.includes("UNIQUE_Code");
      return {
        ...state,
        message: {
          title: "Item",
          text: hasUniqueCode ? "Item is duplicate code." : payload,
          severity: SEVERITY.DANGER,
        },
      };
    case STOCK_IN_CLEAR_ERROR:
      return {
        ...state,
        loading: false,
        message: null,
      };
    default:
      return state;
  }
};

export default StockIn;
